import React from 'react'
import './Dengue.css'
import TextAreaAnt from '../../../UIComponents/TextArea/TextArea'
import { TestReportRightSection } from './TestReportRightSection'
import ReportFooter from './ReportFooter'
import { useDispatch,useSelector } from 'react-redux'
import { useState } from 'react'
import { field,updateReports } from '../../../redux/actions/Diagnostics/diagnostics'

export const Dengue = () => {
  const dispatch =  useDispatch()
  const reportDataFields = useSelector(state => state?.diagnosticsInvoiceSummary?.getdiagnostic)
  const indexValue = useSelector(state => state?.diagnosticsInvoiceSummary?.indexValue) 
  const [ inputValue, setInputValue ] = useState("")

  const onInputChange = (e) => {
    console.log("e",e.target);
    const { value, name } = e.target;
    setInputValue(value)
    const filterData = reportDataFields?.testReport?.filter(item => item.test === 'DENGUE IgG-IgM')
    let index = 0
    reportDataFields?.testReport?.map((item, i) => {
      if(item.test === 'DENGUE IgG-IgM'){
        index = i
      }
      return item
    })
    console.log("index",index);
    const finalFilteredData = filterData[0]?.fields?.map(item => {
      if(item.particular === name){
        item.result = value
      }
      return item
    })
    filterData[0].fields =  finalFilteredData
    reportDataFields.testReport[index]  = filterData[0]
    console.log("knklenknek",reportDataFields?.testReport[index]?.fields);
    setInputValue(reportDataFields?.testReport[index]?.fields)
    dispatch(updateReports(reportDataFields))
  }
  const onLabelClicked = (value) =>{
    dispatch(field({fieldKey:value}))  }
  return (
    <div>
        
            <div className='dengue-parent'>
              <div className='dengue-left'>
                  <div className='dengue-grid'>
                      <div className='deng1 dng-pad' onClick={() => onLabelClicked("NS1 ANTIGEN")}  >NS1 ANTIGEN</div>
                      <div className='deng2 dng-text'><TextAreaAnt name="NS1 ANTIGEN" onChange={onInputChange} value={reportDataFields?.testReport?.[indexValue]?.fields?.[0]?.result}  disabled={!reportDataFields.active} /></div>
                      <span className='dng-border'></span>
                      <div className='dng-pad' onClick={() => onLabelClicked("IgM ANTIBODY")} >IgM ANTIBODY</div>
                      <div className='dng-text '><TextAreaAnt name="IgM ANTIBODY"  onChange={onInputChange} value={reportDataFields?.testReport?.[indexValue]?.fields?.[1]?.result}  disabled={!reportDataFields.active} /></div>
                      <span className='dng-border2'></span>
                      <div className='dng-pad'  onClick={() => onLabelClicked("IgG ANTIBODY")} >IgG ANTIBODY</div>
                      <div className='dng-text'><TextAreaAnt  name="IgG ANTIBODY" onChange={onInputChange}value={reportDataFields?.testReport?.[indexValue]?.fields?.[2]?.result}  disabled={!reportDataFields.active} /></div>
                      <span className='dng-border3'></span>
                  </div>
              </div>
              <div>
                  <TestReportRightSection />
              </div>
            </div>
            <div className='dng-foot'>
                <ReportFooter />
            </div>
            <div className='dng-method'>
              <h4>Method:</h4>
              <p>RAPID TEST</p>
            </div>
       
    </div>
  )
}
